import React from 'react'
import { storiesOf } from '@storybook/react'
import { action } from '@storybook/addon-actions'

import SelectMatchScreen from 'routes/SelectMatch/SelectMatchScreen/SelectMatchScreen'
import SelectMatch from 'routes/SelectMatch/SelectMatchScreen/SelectMatch'
import { withRouter } from 'react-router'
import { MatchesResponse } from 'protos'

// fake data

const fakeMatchesResponse = MatchesResponse.fromObject({
  date: [
    {
      date: 1529452800,
      competition: [
        {
          competition: {
            competitionId: 'wc:2018',
            name: 'World Cup 2018',
          },
          match: [
            {
              matchId: 'match:1',
              homeTeam: { name: 'Columbia' },
              awayTeam: { name: 'Japan' },
              kickoff: 1529503200,
            },
            {
              matchId: 'match:2',
              homeTeam: { name: 'Poland' },
              awayTeam: { name: 'Senegal' },
              kickoff: 1529506800,
            },
            {
              matchId: 'match:3',
              homeTeam: { name: 'Russia' },
              awayTeam: { name: 'Egypt' },
              kickoff: 1529510400,
            },
          ]
        },
        {
          competition: {
            competitionId: 'hu:nb1:2018',
            name: 'OTP Bank Liga',
          },
          match: [
            {
              matchId: 'match:4',
              homeTeam: { name: 'Ferencvárosi TC' },
              awayTeam: { name: 'Videoton' },
              kickoff: 1529503200,
            },
            {
              matchId: 'match:5',
              homeTeam: { name: 'Haladás' },
              awayTeam: { name: 'Honvéd' },
              kickoff: 1529506800,
            },
          ]
        }
      ]
    },
    {
      date: 1529539200,
      competition: [
        {
          competition: {
            competitionId: 'wc:2018',
            name: 'World Cup 2018',
          },
          match: [
            {
              matchId: 'match:6',
              homeTeam: { name: 'Columbia' },
              awayTeam: { name: 'Japan' },
              kickoff: 1529568000,
            },
            {
              matchId: 'match:7',
              homeTeam: { name: 'Poland' },
              awayTeam: { name: 'Senegal' },
              kickoff: 1529587800,
            },
          ]
        }
      ]
    }
  ]
})

// stories

const stories = storiesOf('SelectMatchScreen', module)

stories
  .add('SelectMatchScreen', () => {
    const SelectMatchScreenContainer = withRouter(SelectMatchScreen)

    return (
      <div style={{ margin: -8 }}>
        <SelectMatchScreenContainer
          getAllActiveMatches={() => Promise.resolve(fakeMatchesResponse)}
          getFeaturedActiveMatches={() => Promise.resolve(fakeMatchesResponse)}
          onMatchSelect={action('onMatchSelect')}
        />
      </div>
    )
  })
  .add('SelectMatch', () => {
    return (
      <div style={{ margin: -8 }}>
        <SelectMatch dateGroups={fakeMatchesResponse.date} onMatchSelect={action('onMatchSelect')} />
      </div>
    )
  })
